import {
  SimpleForm,
  TextInput,
  useDataProvider,
  useNotify,
  useRedirect,
} from "react-admin";

import { FileInputSingle } from "../fileInput/fileInput";

export function BulkNotifications({ ...props }) {
  const provider = useDataProvider();
  const notify = useNotify();
  const redirect = useRedirect();
  return (
    <>
      <SimpleForm
        onSubmit={(data) => {
          console.log(123);
          provider
            .bulkNotification(data)
            .then(() => {
              notify("Successfully sent bulk notifications", {
                type: "success",
              });
              redirect("/");
            })
            .catch((err) => {
              notify("Some Problem Occured", { type: "error" });
            });
        }}
      >
        <TextInput source="notification.title" label="title" />
        <TextInput source="notification.body" label="body" />
        <FileInputSingle source="notification.imageUrl" title="Upload Image" />
      </SimpleForm>
    </>
  );
}
